module.exports = __webpack_public_path__ + "img/card-o.688df579.svg";